class SiteCardRequestCommand
{
    private _request: IActionTypeRequest;
    private _card: ISiteCard;

    constructor(
        card: ISiteCard,
        request: IActionTypeRequest)
    {
        this._request = request;
        this._card = card;
    }

    execute(): Promise<boolean> {
        let model: any | undefined;
        let path: string[] = [];

        model = this._request.actionLink.model;

        // When we submit:
        if (this._request.type == 'Submit') {
            let submit = this._request as IActionTypeSubmit;

            path = (submit.path && SiteModel.split(submit.path)) || [];

            // Check if we need to set the model:
            if (submit.setModel)
                model = this._card.Model.get(path);
        }

        // Convert model, when not null or undefined
        if (model != null) {
            return this._card.Container.request(this._card, { 
                request: this._request.actionLink.actionInfo, 
                path: path, 
                model: JSON.stringify(model) 
            });
        }

        return this._card.Container.request(this._card, {
            request:this._request.actionLink.actionInfo
        });
    }
}